/**
 * Batched URL param cleanup — multiple handlers schedule param removal,
 * all batched into ONE `history.replaceState` call qua microtask.
 *
 * Use case: WebInApp URL `?token=&lat=&lng=&webinapp=` — auth provider
 * remove `token`, location handler remove `lat/lng`, webinapp provider
 * remove `webinapp`. Trước: 3 replaceState calls (+ 1000ms setTimeout).
 * Sau: 1 replaceState trong cùng microtask.
 */

const pendingRemovals = new Set<string>();
let scheduled = false;

export function scheduleParamRemoval(...names: string[]) {
  if (typeof window === 'undefined') return;
  names.forEach((n) => pendingRemovals.add(n));

  if (scheduled) return;
  scheduled = true;

  queueMicrotask(flushRemovals);
}

function flushRemovals() {
  scheduled = false;
  if (pendingRemovals.size === 0) return;

  try {
    const url = new URL(window.location.href);
    let changed = false;
    pendingRemovals.forEach((name) => {
      if (url.searchParams.has(name)) {
        url.searchParams.delete(name);
        changed = true;
      }
    });
    pendingRemovals.clear();
    if (changed) window.history.replaceState({}, '', url.toString());
  } catch {
    /* ignore */
  }
}
